
export const generateNumbers = (max) =>
  Array.from({ length: max }, (_, i) => i.toString().padStart(2, "0"));